export default class MarkChain {
  constructor() {
    if(new.target === MarkChain)
      throw new TypeError('MarkChain is abstract');
  }

  *iterate() {}

  static mark(m, point) {
    if(typeof(m) !== 'object')
      return { ...point, mark: `${m}` };
    else
      return { ...m, mark: `${m.mark || '?'}`, ...point };
  }
}

export class SimpleMarkChain extends MarkChain {
  constructor(game) {
    super();
    this.game = game;
    this.marks = [];
  }

  mark(m, coords) {
    this.marks.push(MarkChain.mark(m, this.game.decode(coords)))
    return this;
  }

  clear() {
    this.marks = [];
  }

  *iterate() {
    for(const m of this.marks)
      yield m;
  }
}
